import styled from 'styled-components';
import { Color } from '../../../../common/view/color/color';
import { FontWeight } from '../../../../common/view/font';

const Container = styled.div.withConfig({
  componentId: 'side-bar_container',
  displayName: 'SideBar.Container',
})`
  width: 240px;
  height: 100%;

  padding: 10px;

  background: ${Color.black2};
`;

const SectionTitle = styled.div.withConfig({
  componentId: 'side-bar_section-title',
  displayName: 'SideBar.SectionTitle',
})`
  font-size: 13px;
  font-weight: ${FontWeight.l1};
  color: ${Color.white7};

  text-transform: uppercase;
  user-select: none;
`;

const Section = styled.div.withConfig({
  componentId: 'side-bar_section',
  displayName: 'SideBar.Section',
})`
  padding-top: 40px;
`;

export const SideBarStyle = {
  Container,
  SectionTitle,
  Section,
};
